import {UIGameCardController} from './UIGameCardController'
import {UIGameManager} from '../UIGameManager'
import {UIGameAnimation} from '../UIGameEventController'
import {CardView} from '../../ui_canvas_engine/CardView'
import {Point} from '@colonist/game-mechanic-validators'

export interface CardAnimation {
    cardView: CardView
    endPoint: Point
    speed?: number | undefined
}

export class UIGameCardAnimationController implements UIGameAnimation {
    private readonly uiGameManager: UIGameManager

    private readonly ANIMATION_DELAY = 30 // ms
    private readonly animationQueue: CardAnimation[]
    private lastAnimateTime: number
    private readonly cardController: UIGameCardController

    constructor(uiGameManager: UIGameManager, cardController: UIGameCardController) {
        this.uiGameManager = uiGameManager
        this.lastAnimateTime = (new Date()).getTime()
        this.animationQueue = []
        this.cardController = cardController
    }

    onGameTick() {
        this.animate()
    }

    private startAnimation() {
        this.uiGameManager.eventController.registerUIGameAnimation(this)
    }

    private stopAnimation() {
        this.uiGameManager.eventController.unregisterUIGameAnimation(this)
    }

    private animate() {
        if(this.animationQueue.length <= 0) this.stopAnimation()
        if(!this.canAnimateCard()) return

        const objToAnimate = this.animationQueue[0]
        this.animationQueue.shift()
        objToAnimate.cardView.animationController.animateTo(objToAnimate.endPoint, objToAnimate.speed)
    }

    addCardToAnimationQueue(cardView: CardView, endPoint: Point, animationSpeed?: number) {
        this.animationQueue.push({
            cardView: cardView,
            endPoint: endPoint,
            speed: animationSpeed,
        })
        this.startAnimation()
    }

    private canAnimateCard(): boolean {
        if(this.lastAnimateTime + this.ANIMATION_DELAY > (new Date()).getTime()) return false
        if(this.animationQueue.length == 0) return false
        this.lastAnimateTime = (new Date()).getTime()
        return true
    }
}
